import { EntityApi } from '@inter-ikea-storageone/range';
import { addInserts, findInserts, getInsertPositions, replaceKallaxEntity } from '../utils/rotateUtils';
export class KallaxEntityApi extends EntityApi {
    /**
     * @override
     */
    rotate(entity) {
        const productRef = this.getProductRef(entity);
        if (!productRef)
            return;
        const foundInserts = findInserts(entity);
        const insertPosition = foundInserts && getInsertPositions(this, foundInserts);
        const replaceEntityResult = replaceKallaxEntity(this, entity, productRef);
        if (foundInserts && insertPosition && replaceEntityResult?.valid) {
            this.deleteMultiple(foundInserts);
            addInserts(this, insertPosition, replaceEntityResult.placedEntity, productRef);
        }
        return replaceEntityResult;
    }
}
//# sourceMappingURL=KallaxEntityApi.js.map